import React from 'react';
import '../../styles/RateCard.css';

const handleScroll = () => {
  const target = document.getElementById('contextual-articles');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};

const handleScrollContenido = () => {
  const target = document.getElementById('contenido');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};

const handleScrollBanners = () => {
  const target = document.getElementById('banners');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};

const handleScrollEventos = () => {
  const target = document.getElementById('eventos');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};

const handleScrollLives = () => {
  const target = document.getElementById('lives');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};

const handleScrollSpecs = () => {
  const target = document.getElementById('specs');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};


const HeroSection = () => {
  return (
    <section className="hero-section-rate-card">
      <div className='row align-items-end justify-content-center text-center'>
        <div className='col-12'>
          <h1 data-aos="fade-up" data-aos-delay="400">Rate <span>Card</span></h1>
        </div>
        <div className='col-12'>
          <div>
            <h2 data-aos="fade-up" data-aos-delay="600">2026</h2>
          </div>
        </div>
        <div className='col-12'>
          <div className='row justify-content-center align-items-center'>
            <div className='col text-uppercase' data-aos="fade-up" data-aos-delay="400">
                <p onClick={handleScroll}>Contenido</p>
            </div>
            <div className='col text-uppercase' data-aos="fade-up" data-aos-delay="600">
                <p onClick={handleScrollContenido}>Desarrollo Ad Hoc + Contenido</p>
            </div>
            <div className='col text-uppercase' data-aos="fade-up" data-aos-delay="800">
                <p onClick={handleScrollBanners}>Banners</p>
            </div>
            <div className='col text-uppercase' data-aos="fade-up" data-aos-delay="1000">
                <p onClick={handleScrollEventos}>Eventos</p>
            </div>
            <div className='col text-uppercase' data-aos="fade-up" data-aos-delay="1200">
                <p onClick={handleScrollLives}>Lives & Podcast</p>
            </div>
            <div className='col text-uppercase' data-aos="fade-up" data-aos-delay="1400">
                <p onClick={handleScrollSpecs}>SPECS Be Ads</p>
            </div>
          </div>
        </div>
        <div className='col-12'>
          <a onClick={handleScroll} >
            <svg className="scroll-down-icon-rate-card" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#f8f6f5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
